module.exports = __webpack_public_path__ + "img/15.174c0bdc.jpeg";